/**
 * @ngdoc service
 * @name checkins.factory:updateSelectedRsvps
 * @description
 *
 */
angular
    .module('festzelt-os.guestlists')
    .factory('updateRsvps', [
        '$state',
        updateRsvps
    ]);

function updateRsvps() {
    return {
        key: 'update-rsvps',
        title: 'Update Bookings',
        level: 'selected',
        action({}, store) {
            store.state.vm.showMultipleEditor();
        }
    };

}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/workflows/general/update-rsvps.js